"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.trackCustomerAccountNotification = void 0;
const enums_1 = require("../enums");
const trackGA4EventWithCleanUp_1 = require("./trackGA4EventWithCleanUp");
function trackCustomerAccountNotification(notification_message, notification_type) {
    (0, trackGA4EventWithCleanUp_1.trackGA4EventWithCleanUp)({
        eventData: {
            eventName: enums_1.GA4EventName.ShowNotification,
            feature_category: enums_1.GA4FeatureCategory.CustomerAccount,
            notification_type,
            notification_message,
        },
    });
}
exports.trackCustomerAccountNotification = trackCustomerAccountNotification;
//# sourceMappingURL=trackCustomerAccountNotification.js.map